// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-progress-bar[data-v-721720b6]{background-color:transparent !important}.ui-progress-bar[data-v-721720b6]::before{background-color:var(--ui-theme-primary);opacity:0.38;content:\"\";position:absolute;top:0;right:0;bottom:0;left:0}.ui-progress-dots[data-v-721720b6]{margin:auto}.ui-progress-dots>div[data-v-721720b6]{background-color:var(--ui-theme-primary)}\n", ""]);
// Exports
module.exports = exports;
